import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "28",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.01 7.583a4.67 4.67 0 0 1 4.667-4.666 4.67 4.67 0 0 1 4.667 4.666 4.67 4.67 0 0 1-4.667 4.667 4.67 4.67 0 0 1-4.666-4.667m8.273 14.374a2.22 2.22 0 0 1-.595-2.31c.269-.84.98-1.435 1.844-1.552l1.458-.21s.233-.022.303-.163l.467-.934s.058-.093.047-.221a.37.37 0 0 0-.094-.175c-1.015-1.085-2.543-1.809-4.713-1.809H9.333c-4.736 0-6.416 3.465-6.416 6.44 0 2.66 1.411 4.06 4.083 4.06h8.855c.187 0 .306-.14.362-.443l.233-1.342a.33.33 0 0 0-.105-.315zm10.228-1.262a.507.507 0 0 0-.287-.869l-2.323-.33a.52.52 0 0 1-.391-.279l-1.007-1.997a.561.561 0 0 0-.998 0L19.5 19.217a.52.52 0 0 1-.391.28l-2.324.33a.507.507 0 0 0-.287.868l1.68 1.604a.5.5 0 0 1 .149.451l-.384 2.192c-.078.446.4.787.808.577l2.014-1.036a.53.53 0 0 1 .483 0l2.016 1.037c.407.21.883-.13.806-.575l-.384-2.195a.5.5 0 0 1 .149-.451z"
    }, null, -1)
  ])))
}
export default { render: render }